import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getMissionDefaultQnsAction = createAsyncThunk(
    'get-mission-default-qns',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/get-mission-default-qns-ans`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getMissionDefaultQnsSlice = createSlice({
    name: 'get-mission-default-qns',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getMissionDefaultQnsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getMissionDefaultQnsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getMissionDefaultQnsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getMissionDefaultQnsReducer = getMissionDefaultQnsSlice.reducer    